import React, { useEffect, useState } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { getAllData, subtractDays } from '../../../shared/constants'

export default function OpenPosTaskReport() {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })
  console.log({ STATE_DATA: state })

  const filterData = state.data
  const [page, setPage] = React.useState(1)

  useEffect(() => {
    getAllData('GET_OPEN_TASK_REPORT', { page: page, limit: 10, taskType: 'POS' }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item) => {
      return [
        { value: item.rank6Name },
        { value: item.store.name },
        { value: item.area.name },
        { value: item.city.name },
        { value: item.district.name },
        { value: item.state.name },
        { value: item.zone.name },
        { value: item.region.name },
        { value: item.task && item.task.name },
        { value: subtractDays(item.task && item.task.createdAt) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Open Pos Task Report',
    filename: 'open_pos_task_reports',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    // <>asas</>
    <CustomTableLayout
      tableHeadings={[
        'Employee NAme',
        // 'employee code',
        'store',
        // 'store code',
        'area',
        'city',
        'district',
        'state',
        'zone',
        'region',
        'task',
        'Aging',
      ]}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}
